import ActionTypes from "actions/ActionTypes";

const initialState = {
  data: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        user: payload.data.user_data,
      };
    }
    case ActionTypes.TOGGLE_TWO_FACTOR: {
      return {
        data: {
          ...state.data,
          is_active_2fa: !state.data?.is_active_2fa,
        },
      };
    }
    case ActionTypes.USER_SUCCESS: {
      return {
        ...state,
        data: payload.data,
      };
    }
    default:
      return state;
  }
};
